export default __webpack_public_path__ + "locales/el-GR/PeopleTranslations.json?hash=62d8c0c7393fc20d6fd4bdfec5d3141a";